import styled from '../../styles/styled';
import { Box } from './box';
export const Grid = styled(Box)({
    display: 'grid',
});
//# sourceMappingURL=grid.js.map